import { useState } from 'react';
import { faqItems } from '@/mocks/content';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${
                      openIndex === index ? 'subtract' : 'add'
                    }-line text-foreground-400 transition-transform`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}